<template>
  <div>
    <div class="card-test">
      <div :ref="titleText.sec1.title" class="title-text-style">{{titleText.sec1.title}} [{{updateTimeStamp.slice(0,10)}}]</div>
      <CardContent title="" :datetime='updateTimeStamp'>
        <div class="level">
          <div
            class="level-item has-text-centered content"
            v-for="(value, name, i) in status"
            :key="i"
          >
            <div>
              <font-awesome-icon
                color="#1e4b84"
                :icon="icon_status[i]"
                size="2x">
              </font-awesome-icon>
              <div class="color-style"> {{value}} </div>
              <div class="heading-in-stat"> {{name}} </div>
            </div>
          </div>
        </div>
      </CardContent>
      <div :ref="titleText.sec2.title">
      <DriverPerformance />
      </div>
      <!-- <OrderPerformance /> -->
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { titleText } from '@/setting/titleText.js'

export default {
  components: {
    // Sidebar: () => import('@/components/Sidebar.vue'),
    // Content: () => import('@/components/Content.vue'),
    DriverPerformance: () => import('@/views/DriverPerformance.vue'),
    // OrderPerformance: () => import('@/components/OrderPerformance.vue'),
    CardContent: () => import('@/components/CardContent.vue')
    // DropdownMenu: () => import('@/components/DropdownMenu.vue')
  },
  mounted () {
    // console.log(this.titleText.sec1.title)
    this.initStore()
    this.intervalid1 = setInterval(() => {
      this.updateTimeStamp = dayjs().format('YYYY-MM-DD HH:00:00')
      this.initStore()
    }, 600000)
  },
  data () {
    return {
      titleText: titleText,
      updateTimeStamp: dayjs().format('YYYY-MM-DD HH:00:00'),
      intervalid1: '',
      icon_status: ['fa-solid fa-user-check', 'fa-solid fa-check-square', 'fa-solid fa-search',
        'fa-solid fa-truck', 'fa-solid fa-spinner', 'fa-solid fa-exclamation-triangle']
    }
  },
  computed: {
    status () {
      // console.log('current', this.$store.getters['currentStat/status'])
      return this.$store.getters['currentStat/status']
    }
  },
  methods: {
    findAllRef ({ whereRef }) {
      const ref = this.$refs[whereRef]
      console.log('whereRef', whereRef)
      console.log('refffff', { ref })
      window.scrollTo({
        top: ref.offsetTop - 60,
        left: 0,
        behavior: 'smooth'
      })
    },
    async initStore () {
      await this.$store.dispatch('currentStat/getStatus')
    }
  },
  beforedestroy () {
    clearInterval(this.intervalid1)
  }
}
</script>

<style>
.card-test {
  margin-bottom: 50px;
  padding: 25px;
}
.title-text-style {
    text-align: left;
    margin-top: 10px;
    margin-left: 0px;
    margin-bottom: 10px;
    font-size: 30px;
    color: #1E4B84;
}
.heading-in-stat{
  font-size: 20px;
  color: #1E4B84;
}

.color-style{
  color:#86D4B5;
  font-size: 30px;
  margin-top: 10px;
  font-weight: bold;
}
</style>
